import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export enum InmarBlindReturnStatus {
  UNRESOLVED = "unresolved",
  RESOLVED = "resolved",
  DELETED = "deleted",
}

const processedItemSchema_ = z.object({
  itemKey: z.string().optional(),
  description: z.string().optional(),
  quantity: z.number(),
});

export const processedItemSchema: z.ZodType<ProcessedItem> =
  processedItemSchema_;
export interface ProcessedItem extends z.infer<typeof processedItemSchema_> {}

const inmarReturnDataSchema_ = z.object({
  timestamp: z.date(),
  processedItems: z.array(processedItemSchema_),
  boxBarcode: z.string().optional(),
});

export const inmarReturnDataSchema: z.ZodType<InmarReturnData> =
  inmarReturnDataSchema_;
export interface InmarReturnData
  extends z.infer<typeof inmarReturnDataSchema_> {}

const inmarBlindReturnSchema_ = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  status: z.enum(Object.values(InmarBlindReturnStatus)),
  connectedReturn: zExt.objectId().optional(),
  inmarReturnData: inmarReturnDataSchema_,
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const inmarBlindReturnSchema: z.ZodType<InmarBlindReturn> =
  inmarBlindReturnSchema_;

export const InmarBlindReturnZodArraySchema = z.array(inmarBlindReturnSchema_);

export interface InmarBlindReturn
  extends z.infer<typeof inmarBlindReturnSchema_> {}
